import { CampaignAndMatrixList } from "../../../../pages_ua/Campaign/types/interfaces/CampaingTypes";
import { StoreActionType as Type } from "../../types";

type MatrixState = {
    data: CampaignAndMatrixList,
    loading: boolean,
    error: any,
}

const initialState: MatrixState = {
    data: {
        campaignRules: [],
        campaignRuleMatrixes: []
    },
    loading: false,
    error: null,
}

export const matrixReducer = (state : any = initialState, action : any) => {
    switch (action.type) {
        case Type.GET_CAMPAIGN_MATRIX_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case Type.GET_CAMPAIGN_MATRIX_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
            };
        case Type.GET_CAMPAIGN_MATRIX_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}